import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { UserCustomizationsModel } from '@rd/types/user-customizations.model';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  GetUserCustomizations,
  PutUserCustomizations,
} from '../../user-customizations/store/actions/user-customizations.actions';
import { UserCustomizationsState } from '../../user-customizations/store/reducers/user-customizations.reducer';
import {
  getCoreStateGetUserCustomizations,
  getCoreStateGetUserCustomizationsError,
  getCoreStateGetUserCustomizationsLoading,
} from '../../user-customizations/store/selectors/user-customizations.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserCustomizationsFacade {
  constructor(private store: Store<UserCustomizationsState>) {}

  userCustomizations$: Observable<UserCustomizationsModel> = this.store
    .select(getCoreStateGetUserCustomizations)
    .pipe(distinctUntilChanged());

  userCustomizationsLoading$: Observable<boolean> = this.store
    .select(getCoreStateGetUserCustomizationsLoading)
    .pipe(distinctUntilChanged());

  userCustomizationError$: Observable<HttpError | null> = this.store
    .select(getCoreStateGetUserCustomizationsError)
    .pipe(distinctUntilChanged());

  // Actions
  putUserCustomizations(userCustomizations: UserCustomizationsModel): void {
    this.store.dispatch(new PutUserCustomizations(userCustomizations));
  }

  getUserCustomizations(): void {
    this.store.dispatch(new GetUserCustomizations());
  }
}
